export const MONTH_LABELS_LARGE: Record<MonthString, string> = {
  "01": "Jan",
  "02": "Feb",
  "03": "Mar",
  "04": "Apr",
  "05": "May",
  "06": "Jun",
  "07": "Jul",
  "08": "Aug",
  "09": "Sept",
  "10": "Oct",
  "11": "Nov",
  "12": "Dec",
};

export const MONTH_FULL_NAME: Record<MonthString, string> = {
  "01": "January",
  "02": "February",
  "03": "March",
  "04": "April",
  "05": "May",
  "06": "June",
  "07": "July",
  "08": "August",
  "09": "September",
  "10": "October",
  "11": "November",
  "12": "December",
};

export const MONTH_LABELS_SMALL: Record<MonthString, string> = {
  "01": "J",
  "02": "F",
  "03": "M",
  "04": "A",
  "05": "M",
  "06": "J",
  "07": "J",
  "08": "A",
  "09": "S",
  "10": "O",
  "11": "N",
  "12": "D",
};
